module.exports = new __parcel__URL__("boceto1.eb5fb064.png").toString();